import { HorizontalDividerContainer } from './horizontal-divider.styled';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line react/jsx-props-no-spreading
export const HorizontalDivider = ({ ...otherProps }: never | Record): JSX.Element => <HorizontalDividerContainer { ...otherProps } />;
